import { fetchQuery } from 'react-relay';
import environment from 'shared/relay/environment';
import deliveryNotReceivedContextQuery from '../../../shared/relay/queries/deliveryNotReceivedContext.query';

const getDnrContext = uuid => {
  return new Promise((resolve, reject) =>
    fetchQuery(environment, deliveryNotReceivedContextQuery, {
      pdcbr_uuid: uuid
    })
      .then(queryProps => resolve(queryProps))
      .catch(error => reject(error))
  );
};

function dnrContextService() {
  return {
    getDnrContext
  };
}

export default dnrContextService();
